export default __webpack_public_path__ + "static/media/iconDelete.c0febd2a.svg";